(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nov-quickview"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__jmQuickViewA11yBound) return;
  window.__jmQuickViewA11yBound = true;

  let trigger = null;
  let quickViewOpen = false;
  let popupBound = false;
  let activePopup = null;
  let popupLifecycleObserver = null;
  let popupLifecycleRoot = null;
  let focusFrame = null;
  let readinessGuardFrame = null;
  let readinessGuardStartedAt = 0;
  let redirectingFocus = false;
  const now = () => window.performance?.now ? window.performance.now() : Date.now();
  const requestFrame = window.requestAnimationFrame
    ? (callback) => window.requestAnimationFrame(callback)
    : (callback) => {
        return setTimeout(() => callback(now()), 16);
      };
  const cancelFrame = window.cancelAnimationFrame
    ? (frame) => window.cancelAnimationFrame(frame)
    : (frame) => clearTimeout(frame);

  const focusableControls = (popup) => Array.from(popup.querySelectorAll(
    'a[href], button, input, select, textarea, [tabindex]'
  )).filter((control) => control.tabIndex >= 0 && !control.disabled &&
    !control.closest('[inert], [aria-hidden="true"]') &&
    control.getClientRects().length > 0 && getComputedStyle(control).visibility !== 'hidden');

  const cancelFocusFrame = () => {
    if (focusFrame === null) return;
    cancelFrame(focusFrame);
    focusFrame = null;
  };

  const cancelReadinessGuard = () => {
    if (readinessGuardFrame === null) return;
    cancelFrame(readinessGuardFrame);
    readinessGuardFrame = null;
  };

  const popupIsVisuallyReady = (popup) => {
    const rect = popup.getBoundingClientRect();
    if (!rect.width || !rect.height) return false;
    let element = popup;
    while (element && element !== document.documentElement) {
      const style = getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden' ||
        style.visibility === 'collapse' || Number.parseFloat(style.opacity) === 0) return false;
      if (element === popupLifecycleRoot) break;
      element = element.parentElement;
    }
    return true;
  };

  const focusPopup = () => {
    if (!quickViewOpen || !activePopup?.isConnected || activePopup.contains(document.activeElement)) return;
    const close = activePopup.querySelector('.nov-close');
    const targets = [close, ...focusableControls(activePopup), activePopup].filter(Boolean);
    for (const target of targets) {
      target.focus({ preventScroll: true });
      if (activePopup.contains(document.activeElement)) return;
    }
  };

  const decoratePopup = (popup) => {
    popup.setAttribute('tabindex', '-1');
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    const title = popup.querySelector('h2[id]');
    if (title) popup.setAttribute('aria-labelledby', title.id);

    const controls = [
      ['.nov-close', 'closeLabel'],
      ['.arrow-prev', 'prevLabel'],
      ['.arrow-next', 'nextLabel']
    ];
    controls.forEach(([selector, label]) => {
      const control = popup.querySelector(selector);
      if (!control) return;
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      if (selector === '.nov-close') control.setAttribute('autofocus', '');
      if (trigger?.dataset[label]) control.setAttribute('aria-label', trigger.dataset[label]);
    });
  };

  const schedulePopupFocus = () => {
    if (focusFrame !== null || !quickViewOpen || !activePopup?.isConnected ||
      activePopup.contains(document.activeElement)) return;
    focusFrame = requestFrame(() => {
      focusFrame = null;
      if (!quickViewOpen || !activePopup?.isConnected || !popupIsVisuallyReady(activePopup) ||
        activePopup.contains(document.activeElement)) return;
      decoratePopup(activePopup);
      focusPopup();
    });
  };

  const runReadinessGuard = (timestamp) => {
    readinessGuardFrame = null;
    if (!quickViewOpen || !activePopup?.isConnected || timestamp - readinessGuardStartedAt > 3000) return;
    decoratePopup(activePopup);
    if (popupIsVisuallyReady(activePopup) && !activePopup.contains(document.activeElement)) focusPopup();
    readinessGuardFrame = requestFrame(runReadinessGuard);
  };

  const startReadinessGuard = () => {
    cancelReadinessGuard();
    readinessGuardStartedAt = now();
    readinessGuardFrame = requestFrame(runReadinessGuard);
  };

  const onPopupLifecycleReady = () => {
    if (!quickViewOpen || !activePopup?.isConnected) return;
    decoratePopup(activePopup);
    schedulePopupFocus();
  };

  const disconnectPopupLifecycle = () => {
    popupLifecycleObserver?.disconnect();
    popupLifecycleObserver = null;
    if (popupLifecycleRoot) {
      popupLifecycleRoot.removeEventListener('transitionend', onPopupLifecycleReady, true);
      popupLifecycleRoot.removeEventListener('animationend', onPopupLifecycleReady, true);
    }
    popupLifecycleRoot = null;
    cancelFocusFrame();
    cancelReadinessGuard();
  };

  const observePopupLifecycle = (popup) => {
    disconnectPopupLifecycle();
    popupLifecycleRoot = popup.closest('.nov-wrap') || popup;
    popupLifecycleRoot.addEventListener('transitionend', onPopupLifecycleReady, true);
    popupLifecycleRoot.addEventListener('animationend', onPopupLifecycleReady, true);
    popupLifecycleObserver = new MutationObserver(() => {
      if (!quickViewOpen || !activePopup?.isConnected) return;
      decoratePopup(activePopup);
      schedulePopupFocus();
    });
    popupLifecycleObserver.observe(popupLifecycleRoot, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
  };

  const installVendorFocusBridge = () => {
    const instance = window.jQuery?.magnificPopup?.instance;
    if (!instance) return;
    if (!instance.__jmQuickViewFocusBridgeInstalled) {
      const originalSetFocus = instance._setFocus;
      instance.__jmQuickViewFocusBridgeInstalled = true;
      instance._setFocus = function() {
        if (quickViewOpen && activePopup?.isConnected) {
          decoratePopup(activePopup);
          focusPopup();
          return;
        }
        return originalSetFocus?.apply(this, arguments);
      };
    }
    if (instance.st) instance.st.focus = '.nov-close';
  };

  const activatePopup = (popup) => {
    if (!popup?.isConnected) return;
    const isNewPopup = activePopup !== popup;
    quickViewOpen = true;
    activePopup = popup;
    decoratePopup(popup);
    installVendorFocusBridge();
    if (isNewPopup || !popupLifecycleObserver) observePopupLifecycle(popup);
    startReadinessGuard();
    schedulePopupFocus();
  };

  document.addEventListener('focusin', (event) => {
    if (!quickViewOpen || !activePopup?.isConnected || activePopup.contains(event.target) || redirectingFocus) return;
    redirectingFocus = true;
    focusPopup();
    redirectingFocus = false;
  }, true);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.btnProductQuickview');
    if (button) {
      trigger = button;
      bindPopup();
    }
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' && quickViewOpen && activePopup?.isConnected) {
      const controls = focusableControls(activePopup);
      const first = controls[0];
      const last = controls[controls.length - 1];
      const current = document.activeElement;
      if (!first) {
        event.preventDefault();
        activePopup.focus({ preventScroll: true });
      } else if (!activePopup.contains(current) || current === activePopup ||
        (event.shiftKey && current === first) || (!event.shiftKey && current === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
      }
    }
    const close = event.target.closest('#content_quickview .nov-close, #content_quickview .arrow-prev, #content_quickview .arrow-next');
    if (close && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      close.click();
    }
  }, true);
  const bindPopup = () => {
    if (popupBound || !window.jQuery) return;
    popupBound = true;
    installVendorFocusBridge();
    // Techoze's Magnific Popup fork emits nov*, not mfp* events.
    window.jQuery(document).on('novOpen.jmQuickView', () => {
      const popup = document.getElementById('content_quickview');
      if (!popup) return;
      activatePopup(popup);
    }).on('novBeforeClose.jmQuickView', () => {
      quickViewOpen = false;
      disconnectPopupLifecycle();
    }).on('novAfterClose.jmQuickView', () => {
      if (!activePopup) return;
      quickViewOpen = false;
      disconnectPopupLifecycle();
      activePopup = null;
      if (trigger?.isConnected) {
        const opener = trigger;
        const card = opener.closest('.item-product');
        card?.classList.add('jm-qv-focus-return');
        // Restore after the vendor's close event and focus teardown finish.
        setTimeout(() => {
          if (!opener.isConnected) return;
          opener.focus({ preventScroll: true });
          opener.addEventListener('blur', () => card?.classList.remove('jm-qv-focus-return'), { once: true });
        }, 0);
      }
      trigger = null;
    });
  };
  window.addEventListener('load', bindPopup, { once: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindPopup, { once: true });
  } else {
    bindPopup();
  }
})();

/* Slick no longer loads on every page (see nov-head-js.liquid for the
   measurement). The quick-view popup is one of only two places that needs it
   with no [data-section-type="nov-slick"] markup on the page to hang a deferred
   tag on: js-nuranium's initQuickView fetches ?view=quick_view and opens
   Magnific Popup, and that popup's `open` callback runs
   .FeaturedImage_slick.slick(...). Collection and search pages render
   quick-view buttons and build no other Slick carousel, so the library is
   fetched on the first click instead of on every page load.

   The click is gated rather than merely prefetched, so there is no race:
   stopping propagation here keeps jQuery's delegated handler from opening the
   popup before the library has arrived, and the click is then replayed. On the
   second pass $.fn.slick exists and this listener steps aside. A failed fetch
   replays too, so the button ends up behaving exactly as it did before.

   This runs after the listener above registered, so that one still sees every
   click first and records the trigger element for focus return. */
(() => {
  if (window.__jmQuickViewSlickGate) return;
  window.__jmQuickViewSlickGate = true;

  const slickReady = () =>
    !!(window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === 'function');
  let replaying = false;

  document.addEventListener('click', (event) => {
    if (replaying || slickReady() || typeof window.jmLoadSlick !== 'function') return;
    const button = event.target?.closest?.('.btnProductQuickview');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.jmLoadSlick(() => {
      if (!button.isConnected) return;
      replaying = true;
      try {
        button.click();
      } finally {
        replaying = false;
      }
    });
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-single-accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    function syncTrigger(trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      var expanded = trigger.classList.contains('act');
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      panel.hidden = !expanded;
    }

    function setupAccordion(root) {
      if (root.dataset.jmProductAccordionReady === 'true') return;
      root.dataset.jmProductAccordionReady = 'true';
      var triggers = Array.prototype.slice.call(root.querySelectorAll('.product-single__accordion-trigger'));

      triggers.forEach(function (trigger) {
        syncTrigger(trigger);
        new MutationObserver(function () {
          syncTrigger(trigger);
        }).observe(trigger, { attributes: true, attributeFilter: ['class'] });
      });

      root.addEventListener('click', function (event) {
        var trigger = event.target.closest('.product-single__accordion-trigger');
        if (!trigger || !root.contains(trigger)) return;
        window.requestAnimationFrame(function () {
          triggers.forEach(syncTrigger);
        });
      });
    }

    function initialize(scope) {
      (scope || document).querySelectorAll('[data-jm-product-accordion]').forEach(setupAccordion);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initialize(document); });
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initialize(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-single-media-thumb"] && !Shopify.designMode) return;
  try {
    (function () {
    function getFeaturedSlider(root) {
      var photos = root.closest('.product-single__photos');
      return photos ? photos.querySelector('.proFeaturedImage') : null;
    }

    function getSelectedPosition(root) {
      var featured = getFeaturedSlider(root);
      if (!featured) return null;
      var selected = featured.querySelector('.slick-current[data-position]') || featured.querySelector('.item.act[data-position]');
      return selected ? selected.getAttribute('data-position') : null;
    }

    function syncThumbs(root) {
      var selectedPosition = getSelectedPosition(root);
      root.querySelectorAll('.thumbItem').forEach(function (control) {
        var selected = selectedPosition !== null && control.getAttribute('data-position') === selectedPosition;
        control.setAttribute('role', 'button');
        control.setAttribute('aria-pressed', selected ? 'true' : 'false');

        var visual = control.querySelector('.product-single__thumbnail');
        if (visual && visual.getAttribute('tabindex') !== '-1') {
          visual.setAttribute('tabindex', '-1');
        }
      });
    }

    function activateThumb(root, control) {
      var featured = getFeaturedSlider(root);
      var position = Number.parseInt(control.getAttribute('data-position'), 10);
      if (
        featured &&
        Number.isFinite(position) &&
        window.jQuery &&
        featured.classList.contains('slick-initialized')
      ) {
        var featuredSlider = window.jQuery(featured);
        if (typeof featuredSlider.slick === 'function') {
          featuredSlider.slick('slickGoTo', position);
          return;
        }
      }
      control.click();
    }

    function setupThumbs(root) {
      if (root.dataset.jmProductThumbsReady === 'true') return;
      root.dataset.jmProductThumbsReady = 'true';
      var syncQueued = false;

      function queueSync() {
        if (syncQueued) return;
        syncQueued = true;
        window.requestAnimationFrame(function () {
          syncQueued = false;
          syncThumbs(root);
        });
      }

      root.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var control = event.target.closest('.thumbItem[role="button"]');
        if (!control || !root.contains(control)) return;
        event.preventDefault();
        activateThumb(root, control);
        queueSync();
      });
      root.addEventListener('click', queueSync);

      new MutationObserver(queueSync).observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-hidden', 'tabindex']
      });
      syncThumbs(root);
    }

    function initialize(scope) {
      (scope || document).querySelectorAll('[data-jm-product-thumbs]').forEach(setupThumbs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initialize(document); });
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initialize(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
